export const LABEL = 'Question successfully created! You may still continue adding questions to the form or close this if you are done.';
